import styled from 'styled-components';

export const TooltipsStyled = styled.div`
  .item {
    position: relative;
    height: 22px;
  }
  .item_text {
    height: 42px;
    width: 98%;
    line-height: 42px;
    position: absolute;
    left: 0;
    top: -10px;
  }

  .item_text:hover {
    background-color: rgb(209, 217, 237);
    color: rgb(21, 101, 192);
  }

  .ant-timeline-item {
    display: flex;
    padding-bottom: 0;
    height: 42px;
  }

  .ant-timeline.ant-timeline-label .ant-timeline-item-label {
    position: absolute;
    top: -7.001px;
    width: calc(11% - 12px);
    text-align: right;
  }
  div.timeline_container div.ant-timeline-item-tail,
  div.ant-timeline-item-head {
    left: 11% !important;
  }
  .ant-timeline.ant-timeline-label .ant-timeline-item-tail {
    left: 11% !important;
  }
  .WuhRt div.ant-timeline-item-head {
    left: 11% !important;
  }
  .ant-timeline.ant-timeline-label
    .ant-timeline-item-left
    .ant-timeline-item-content {
    left: calc(11% - 4px) !important;
    width: calc(89% - 14px) !important;
  }
`;
